export default "__VITE_ASSET__Bnk1xfw5__"